module.exports = __webpack_public_path__ + "img/emoji_28.31f50259.png";